// extracted by mini-css-extract-plugin
export default {"container":"CommercialTransactions_container__B7avl","title":"CommercialTransactions_title__l9cud"};